<script>
  export let name;
  import { user } from "./refs/store.js";
  import { signout } from "./refs/auth.js";
  import Login from "./Login.svelte";
  import Profile from "./Profile.svelte";
  import Todos from "./Todos.svelte";

  var uid = null;
  $: {
	  uid = $user ? $user.uid : null;
  }
</script>

<style>
  h1 {
    color: purple;
  }
  main {
    margin: 20px;
  }
</style>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/bulma/0.8.0/css/bulma.min.css" />
  <script
    src="https://kit.fontawesome.com/0912216dd7.js"
    crossorigin="anonymous">

  </script>
</svelte:head>
<main>
  <header class="content">
    <h1 class="content">Welcome to {name}</h1>
  </header>

  <Login />

  {#if $user}
    <!-- <section class=""> -->
    <Profile {...$user} on:signout={signout} />
    <!-- </section> -->
    <section class="card is-medium is-centered">
      <Todos { uid } />
    </section>
  {/if}

</main>
